import axios from "axios";
import React, { useState, useRef, useEffect } from "react";
import {
  Backdrop,
  Box,
  Grid,
  Container,
  CircularProgress,
  Button,
  Typography,
  styled,
} from "@mui/material";
import { Field, Formik, Form } from "formik";
import * as yup from "yup";
import { TextField } from "formik-material-ui";
import "../../utils/css/infromationRequired.css";
import bankVerifiedTag from "../../utils/images/Verified.svg";
import bankIcon from "../../utils/images/bankIcon.svg";
import divider from "../../utils/images/divider.svg";
import axiosInstance from "../../../utils/axiosInterceptor";
import {
  FileUploader,
  isSafeFilename,
  checkHarmfulPdfContent,
} from "../../utils/fileUploader";
import loggingService from "../../../services/logging.service";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import uploadIcon from "../../utils/images/upload-04.svg";

export default function BankDetailsPopUp(props) {
  const fileRef = useRef();
  const [bankFile, setBankFile] = useState([]);
  let apiUrl = process.env.REACT_APP_REIMBURSEMENT_URL;
  const [apiFailure, setApiFailure] = useState();
  const [userVerifiedBankList, setUserVerifiedBankList] = useState([]);
  const [message, setMessage] = useState();
  const [loading, setLoading] = useState(true);
  const [bankSelected, setBankSelected] = useState(null);

  const getUerBankDetails = async (accessToken) => {
    try {
      const authHeader = {
        headers: {
          authtoken: accessToken,
        },
      };
      const userBankDetails = await axiosInstance.get(
        `${apiUrl}/auth/getUserBankDetails`,
        authHeader
      );
      if (userBankDetails.data.isSuccess) {
        let userBanks = userBankDetails.data.result.bankdta;
        let userVerifiedBanks = userBanks.filter(
          (bank) => bank.isverified === 1
        );
        setUserVerifiedBankList(userVerifiedBanks);
        setLoading(false);
      } else {
        setMessage("we");
      }
    } catch (error) {
      setMessage("we");
    }
  };

  const submitBankDetails = async () => {
    props.closeHandler();
  };

  const updateBankDetails = async (values) => {
    let funRes;
    const config = {
      headers: {
        authtoken: props.accessToken,
      },
    };
    if (bankSelected != null) {
      const addBankBody = {
        oldaccNo: values.AccountNo,
        bankName: userVerifiedBankList[bankSelected].bankname,
        ifscCode: userVerifiedBankList[bankSelected].ifsccode,
        acholderName: userVerifiedBankList[bankSelected].accountholdername,
        accNo: userVerifiedBankList[bankSelected].accountholdernumber,
        branchName: userVerifiedBankList[bankSelected].branchname,
        isupdationflag: false,
        irflag: 1,
        shiftToOldAccount: true,
        claimId: props.claimId,
      };
      let addBankResponse;
      try {
        addBankResponse = await axiosInstance.post(
          `${apiUrl}/auth/addUserBankDetails`,
          addBankBody,
          config
        );

        if (!addBankResponse.data.isSuccess) {
          funRes = "failure";
        } else {
          funRes = true;
        }
      } catch (error) {
        if (error.response.data.message === "Token_Expired")
          funRes = "Token_Expired";
        else funRes = "failure";
        return funRes;
      }
    } else {
      let formdata = new FormData();
      var bankDocname = bankFile[0].name.split(".");
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0");
      var yyyy = today.getFullYear();
      var date = new Date();
      var hour = date.getHours();
      var min = date.getMinutes();
      var sec = date.getSeconds();
      var milli = date.getMilliseconds();
      today =
        yyyy +
        "_" +
        mm +
        "_" +
        dd +
        "_" +
        hour +
        "_" +
        min +
        "_" +
        sec +
        "_" +
        milli;
      formdata.append(
        "file",
        bankFile[0],
        "PAT" +
          "_" +
          props.bankDetails.employeeid +
          "_" +
          Math.random().toString(16).slice(2) +
          "_" +
          today +
          "." +
          bankDocname[bankDocname.length - 1]
      );
      let fileName =
        "PAT" +
        "_" +
        props.bankDetails.employeeid +
        "_" +
        Math.random().toString(16).slice(2) +
        "_" +
        today +
        "." +
        bankDocname[bankDocname.length - 1];
      let fileType = "BankDocuments";
      let addBankResponse, uploadBankDocResponse;
      uploadBankDocResponse = {
        isSuccess: false,
        Key: `${fileType}/${fileName}`,
      };
      let imageType = `image/${fileName.split(".").pop()}`;
      let singleFiledata = new File([bankFile[0]], fileName, {
        type: imageType,
      });
      try {
        const fileUploadResponse = await FileUploader.uploadFileData(
          props?.entityId,
          singleFiledata,
          fileType
        );
        uploadBankDocResponse.isSuccess = fileUploadResponse.isSuccess;
        uploadBankDocResponse.Key = fileUploadResponse.fileName;
      } catch (error) {
        loggingService.log({
          level: "ERROR",
          method: "POST/PUT",
          message: `Error in uplodaing File :  ${error.message}`,
          error: error,
        });
        if (error.response.data.message === "Token_Expired")
          funRes = "Token_Expired";
        else funRes = "failure";
        return funRes;
      }

      if (uploadBankDocResponse.isSuccess) {
        const addBankBody = {
          bankName: values.Bankname,
          ifscCode: values.IFSCcode,
          acholderName: values.ACHolderName,
          accNo: values.AccountNo,
          branchName: values.BranchName,
          document: uploadBankDocResponse.Key,
          oldaccNo: props.bankDetails.accountholdernumber,
          isupdationflag:
            props.bankDetails.accountholdernumber == values.AccountNo
              ? false
              : true,
          irflag: 1,
        };

        try {
          addBankResponse = await axiosInstance.post(
            `${apiUrl}/auth/addUserBankDetails`,
            addBankBody,
            config
          );
        } catch (error) {
          if (error.response.data.message === "Token_Expired")
            funRes = "Token_Expired";
          else funRes = "failure";
          return funRes;
        }
      }
      if (
        !addBankResponse.data.isSuccess &&
        addBankResponse.data.message === "already present"
      ) {
        funRes = addBankResponse.data.message;
      } else if (
        !uploadBankDocResponse.isSuccess ||
        !addBankResponse.data.isSuccess
      ) {
        funRes = "failure";
      } else {
        funRes = true;
      }
    }
    return funRes;
  };

  const addBankDocuments = async (bankDocument) => {
    const filesArray = Array.from(bankDocument || []);
    setBankFile([]);
    const output = document.getElementById("bankFileList");

    if (!filesArray.length) {
      output.innerHTML =
        "<p class='error-message'> Please upload bank document </p>";
      return;
    }

    let documentSize = 0;
    let children = "";
    let documentType = false;
    let zerobyteflag = 0;

    for (let i = 0; i < filesArray.length; ++i) {
      const currentFile = filesArray[i];

      if (currentFile.size === 0) {
        zerobyteflag = 1;
        break;
      }

      documentSize += currentFile.size / 1000;
      children += `<li>${currentFile.name}</li>`;

      if (!isSafeFilename(currentFile.name)) {
        output.innerHTML =
          "<p class='error-message'> File name contains unsupported characters. Please use letters, numbers, or basic symbols only. </p>";
        return;
      }

      if (
        !(
          currentFile.type === "application/pdf" ||
          currentFile.type === "image/png" ||
          currentFile.type === "image/jpg" ||
          currentFile.type === "image/jpeg"
        )
      ) {
        documentType = true;
      }
    }

    if (!zerobyteflag && !documentType) {
      try {
        const isPdfSafe = await checkHarmfulPdfContent(filesArray);
        if (!isPdfSafe) {
          output.innerHTML =
            "<p class='error-message'> Invalid or harmful file detected. Please upload valid PDF files only. </p>";
          return;
        }
      } catch (error) {
        output.innerHTML =
          "<p class='error-message'> Error validating PDF content. Please try again. </p>";
        return;
      }
    }

    if (zerobyteflag) {
      output.innerHTML =
        "<p class='error-message'> Can't upload zero byte file </p>";
    } else if (documentType) {
      output.innerHTML =
        "<p class='error-message'> Upload Only Image or PDF </p>";
    } else if (documentSize > 10000) {
      output.innerHTML =
        "<p class='error-message'> File Size is beyond 50MB </p>";
    } else {
      output.innerHTML = children;
      setBankFile(filesArray);
    }
  };

  const toggleSelectedBank = (index) => {
    if (bankSelected == index) setBankSelected(null);
    else setBankSelected(index);
  };

  const BorderCard = styled("div")`
    box-sizing: border-box;
    border-radius: 15px;
    width: 276px;
    max-width: 100%;
    margin: 5px;
    position: relative;
    border: ${(props) =>
      props.selected ? "1.5px solid #1C6EF2" : "1px solid #d5dde3"};
  `;
  const BankCard = ({ option, selected, onChange, index }) => {
    return (
      <BorderCard selected={selected}>
        <Box onClick={onChange}>
          <Box className="bankCardDiv" style={{ height: "190px" }}>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                padding: "6px 12px",
                borderTopRightRadius: "15px",
                borderBottomLeftRadius: "12px",
                fontSize: "10px",
                fontWeight: 600,
                backgroundColor: "#F1F8F5",
                color: "#26935F",
              }}
            >
              Verified
            </Box>
            <div className="Bank_Name" style={{ paddingBottom: "10px" }}>
              {option.bankname ? option.bankname : "BANK DETAILS"}
            </div>
            <div key="bankname" className="p-b-5 bankDetails">
              Account Holder : {option.accountholdername || option.benef_name_bank_returned}
            </div>
            <div key="bankaccno" className="p-b-5 bankDetails">
              Account Number : {option.accountholdernumber}
            </div>
            <div key="bankiifsccode" className="p-b-5 bankDetails">
              IFSC Code : {option.ifsccode}
            </div>
            <div key="bankbranch" className="p-b-5 bankDetails">
              {option.branchname ? <> Branch : {option.branchname} </> : ""}
            </div>
          </Box>
        </Box>
      </BorderCard>
    );
  };

  useEffect(() => {
    getUerBankDetails(props.accessToken);
  }, []);

  return (
    <>
      {loading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          {" "}
          {message ? (
            <p sx={{ color: "#212529" }}>
              <strong>{message}</strong>
            </p>
          ) : (
            <CircularProgress color="inherit" />
          )}
        </Backdrop>
      ) : (
        <Container>
          {userVerifiedBankList.length > 0 ? (
            <>
              <p className="bankHeading">
                You may either select a verified bank account from below or
                update the bank account details you provided.
              </p>
              <br />
            </>
          ) : (
            <></>
          )}
          <div className="flex flex-wrap">
            {userVerifiedBankList.length > 0 ? (
              userVerifiedBankList.map((option, index) => (
                <Box key={index} sx={{ marginRight: { md: "15px" } }}>
                  <Box
                    className="min-width-250 border-radius-10"
                    style={{
                      border: "5px",
                      borderColor: "black",
                      fontSize: "14px",
                    }}
                    key="bankcard"
                    id={index}
                  >
                    <BankCard
                      id={index}
                      key={index}
                      index={index}
                      option={option}
                      selected={bankSelected === index}
                      onChange={(e) => {
                        toggleSelectedBank(index);
                        // props.onSelect(index);
                      }}
                    />
                  </Box>
                </Box>
              ))
            ) : (
              <></>
            )}
          </div>
          <br />
          {userVerifiedBankList.length > 0 && bankSelected == null ? (
            <>
              <img src={divider} style={{ width: "100%" }} /> <br />
              <br />
              <p className="bankHeading">
                Provide correct bank account details/proofs for us to verify
                your bank account
              </p>
            </>
          ) : (
            <></>
          )} 
          <Formik
            initialValues={{
              AccountNo: props.bankDetails.accountholdernumber,
              ReAccountNo: props.bankDetails.accountholdernumber,
              Bankname: props.bankDetails.bankname,
              IFSCcode: props.bankDetails.ifsccode,
              BranchName: props.bankDetails.branchname,
              ACHolderName: props.bankDetails.accountholdername || props.bankDetails.benef_name_bank_returned,
              file: null,
            }}
            onSubmit={async (values) => {
              let res = await updateBankDetails(values);
              if (res === "already present") {
                setApiFailure(
                  "You are trying to add an already existing bank account with account number " +
                    values.AccountNo +
                    ". Please try adding a new bank account."
                );
              } else if (res === "failure") {
                setApiFailure(
                  "Failed to update bank details. Please try again"
                );
              } else if (res === "Token_Expired") {
                setApiFailure("Session expired please login again");
              } else {
                submitBankDetails();
              }
            }}
            validationSchema={yup.object().shape({
              AccountNo: yup
                .string()
                .required("Account Number is Required")
                .matches(/^[0-9]+$/, "Account number must be in numbers")
                .min(5, "Must be min 5 digits")
                .max(18, "Cannot exceed 18 digits"),
              ReAccountNo: yup.string().when("AccountNo", {
                is: (val) => val && val.length > 0,
                then: (schema) =>
                  schema
                    .required("Re-enter Account Number is Required")
                    .oneOf(
                      [yup.ref("AccountNo")],
                      "Account number didn't match"
                    ),
                otherwise: (schema) => schema.notRequired(),
              }),
              Bankname: yup
                .string()
                .required("Bank Name is Required")
                .matches(
                  /^[A-Za-z ]+$/,
                  "Bank name cannot contain numbers and special characters"
                ),
              IFSCcode: yup
                .string()
                .required("IFSC Code Is Required")
                .test(
                  "IFSC Code",
                  "IFSC Code must be of length 11",
                  (value) => value?.length === 11
                )
                .matches(
                  /^[A-Z]{4}0[A-Z0-9]{6}$/,
                  "IFSC code must be 4 uppercase letters, followed by 0, then 6 alphanumeric characters"
                ),
              BranchName: yup
                .string()
                .required("Branch Name is Required")
                .matches(
                  /^[A-Za-z ]+$/,
                  "Branch name cannot contain numbers and special characters"
                ),
              ACHolderName: yup
                .string()
                .required("AC Holder Name is Required")
                .matches(
                  /^[A-Za-z ]+$/,
                  "AC Holder name cannot contain numbers and special characters"
                ),
            })}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form autoComplete="off">
                {bankSelected == null ? (
                  <>
                    <Grid container spacing={2} marginTop="1px">
                      <Grid item xs={12} sm={6}>
                        <Field
                          style={{ width: "100%" }}
                          component={TextField}
                          id="AccountNo"
                          name="AccountNo"
                          label="Account No"
                          type="password"
                          onPaste={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          onCopy={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          required={true}
                        >
                          Account No{" "}
                        </Field>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field
                          style={{ width: "100%" }}
                          component={TextField}
                          id="ReAccountNo"
                          name="ReAccountNo"
                          label="Re Account No"
                          disabled={values.AccountNo === "" ? true : false}
                          onPaste={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          onCopy={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                        >
                          Re Account No{" "}
                        </Field>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field
                          style={{ width: "100%" }}
                          component={TextField}
                          id="Bankname"
                          name="Bankname"
                          label="Bank Name"
                          required={true}
                        >
                          Bank Name{" "}
                        </Field>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field
                          style={{ width: "100%" }}
                          component={TextField}
                          id="IFSCcode"
                          name="IFSCcode"
                          label="IFSC code"
                          required={true}
                        >
                          IFSC code{" "}
                        </Field>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field
                          style={{ width: "100%" }}
                          component={TextField}
                          id="BranchName"
                          name="BranchName"
                          label="Branch Name"
                          required={true}
                        >
                          Branch Name{" "}
                        </Field>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field
                          style={{ width: "100%", borderRadius: "10px" }}
                          component={TextField}
                          id="ACHolderName"
                          name="ACHolderName"
                          label="Account Holder Name"
                          required={true}
                        >
                          AC Holder Name{" "}
                        </Field>
                      </Grid>
                    </Grid>

                    <br />

                    <h6 className="docHeading">Upload Document</h6>
                    <div style={{ display: "inline-block" }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginBottom: 2,
                        }}
                      >
                        <InfoOutlinedIcon
                          sx={{
                            color: "#1778F2",
                            fontSize: "18px",
                            marginRight: 1,
                            marginTop: "2px",
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "14px",
                            color: "#47566A",
                            lineHeight: 1.5,
                          }}
                        >
                          Bank Statement or Cancelled Cheque.
                        </Typography>
                      </Box>
                    </div>
                    <div>
                      <Box
                        onClick={() => {
                          fileRef.current.click();
                        }}
                        sx={{
                          border: "1px solid #DBE0E6",
                          borderRadius: "9px",
                          padding: "12px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          backgroundColor: "#FFFFFF",
                          width: {
                            xs: "120px",
                            sm: "135px",
                            md: "130px",
                          },
                          height: {
                            xs: "120px",
                            sm: "135px",
                            md: "130px",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                      >
                        <input
                          ref={fileRef}
                          hidden
                          id="file"
                          name="file"
                          value={""}
                          type="file"
                          onChange={async (e) => {
                            await addBankDocuments(e.target.files);
                            setFieldValue("File", e.target.files[0]);
                          }}
                        />

                        <img
                          src={uploadIcon}
                          alt="Upload"
                          style={{
                            width: "30px",
                            height: "30px",
                            marginBottom: "8px",
                            color: "#252D38",
                          }}
                        />

                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#252D38",
                            textAlign: "center",
                          }}
                        >
                          Upload Document
                        </Typography>
                      </Box>
                    </div>
                    <br />
                    <ul id="bankFileList" className="file-list"></ul>

                    {apiFailure ? (
                      <p style={{ marginTop: "10px", color: "#FC1721" }}>
                        {apiFailure} &nbsp;
                      </p>
                    ) : (
                      <></>
                    )}
                    <br />
                    <br />
                    <br />
                    <br />
                  </>
                ) : (
                  <></>
                )}

                <div className="footer">
                  <Button
                    variant="contained"
                    style={{ width: "90%", left: "5%" }}
                    startIcon={
                      isSubmitting ? <CircularProgress size="1rem" /> : null
                    }
                    disabled={
                      bankFile.length > 0 || bankSelected != null
                        ? isSubmitting
                        : true
                    }
                    type="submit"
                    sx={{
                      backgroundColor: "#0066DC",
                      color: "#FFFFFF",
                    }}
                  >
                    {isSubmitting ? "Processing" : "Save"}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Container>
      )}
    </>
  );
}
